// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Base, Text } from '@gandi/ui';

import styles from './DiscountPrice.scss';

type Props = {
  currency: string,
  minDuration: number,
  normalPrice: number,
  price: number,
  children: React.Node,
};

export function DiscountPrice({
  currency,
  minDuration,
  normalPrice,
  price,
  children,
}: Props): React.MixedElement {
  const { __, formatPrice } = useTranslator();

  return (
    <Base flex flexCol className={styles.discountPriceContainer}>
      <Base flex flexGrow1>
        {/* duration + normal price */}
        <Base flex>
          <Text>{__('%(count)s year at', { count: minDuration })}</Text>
          <Text decoration="line-through">
            {' '}
            {formatPrice(normalPrice * minDuration, currency)}{' '}
          </Text>
        </Base>
        {/* discounted price */}
        <Base weight="semibold" className={styles.discountPrice}>
          {formatPrice(price * minDuration, currency)}
        </Base>
      </Base>
      {children}
    </Base>
  );
}
